import { GLOBAL } from 'saddlebag-browser';

/**
 * @param {string} parameters Query parameters in string format
 * @returns {object} Query parameters in JSON format
 */
export const parseParams = (parameters = '') => {
  const globalWindow = GLOBAL.getWindow();
  // globalWindow?.location?.search guards against undefined window in test environments and SSR
  const paramsStr: string = (parameters || globalWindow?.location?.search) ?? '';
  const params = new URLSearchParams(paramsStr);
  const out: Record<string, any> = {};
  params.forEach((value, key) => {
    if (key !== '' && !value.includes('=')) {
      out[key] = value || null;
    }
  });

  return out;
};
